module.exports = __webpack_public_path__ + "static/media/Residential-Construction.44ba5bdc.jpg";